import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import PurchaseButton from './PurchaseButton'

class TicketSelections extends Component {

    renderSelections() {
        const { store } = this.props;                   
        return (
            <span>
                <div className="row align-items-center">
                    <div className="col-md-4 text-center text-md-left">
                        <h5 className="text-muted">                
                            Total: USD ${store.getTotal()}               
                        </h5>
                    </div>
                    <div className="col-md-4 text-center text-md-center">
                        <h5 className="text-muted">                
                            Quantity: {store.getTotalQuantity()}               
                        </h5>
                    </div>                    
                    <div className="col-md-3 offset-md-1 col-lg-2 offset-lg-2 text-md-right">
                        <h5>                          
                            <PurchaseButton />
                        </h5>
                    </div>                                        
                </div>                                                
            </span>
        )
    } 

    render() {
        return (
            <div className="container">
                {this.renderSelections()}
            </div>
        );
    }

}

export default inject('store')(observer(TicketSelections));



// WEBPACK FOOTER //
// ./src/components/TicketSelections.js